export const PIN_PROVIDER: "Pin Provider" = "Pin Provider";
export const API_PROVIDER: "API Provider" = "API Provider";
export const API_TEMP_PROVIDER: "Both Provider" = "Both Provider";

export const breadcrumbItems = [
  // { label: "Dashboard", path: "dashboard" },
  { label: "Categories List" },
];

export const statusOption: any = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Archive", value: "Archive" },
];
export const paymentOption: any = [
  { label: "Paid", value: "paid" },
  { label: "Unpaid", value: "unpaid" },
  { label: "Pending", value: "pending_confirmation" },
  { label: "Rejected", value: "rejected" },
];

export const sortingOption: any = [
  { label: "Ascending", value: "asc" },
  { label: "Descending", value: "desc" },
];

export const otherSortingOption: any = [
  // { label: "Recent", value: "recent" },
  // { label: "Oldest", value: "oldest" },
];

// "active", "closed", "awaiting_customer", "on_hold"

export const HelpTicketsSection: any = [
  { label: "Active", value: "active" },
  { label: "Closed", value: "closed" },
  { label: "Awaiting Response from Customer", value: "awaiting_customer" },
  { label: "Hold", value: "on_hold" },
];

export const fullSortingOptions: any = [
  ...sortingOption,
  ...otherSortingOption,
];

/**
 * The top-level categories, as stored in each category's
 * `parentCategoryName`. A parent is not a record in this system, it is that
 * string, so this list is what every screen offers.
 *
 * International Top Up was missing, which made it unselectable on the
 * Categories list, its filter panel and Notifications -- while Add Product
 * happily offered the categories sitting under it. It has been a real
 * top-level category since 24 Sep, holding sub-categories and 16 products,
 * so leaving it out of this list only hid it from the screens that manage it.
 *
 * Travel is not here on purpose: those products come from FlixBus directly
 * and there is no category for an admin to file under it.
 */
export const parentCategories: any = [
  { label: "Gift Cards", value: "Gift Cards" },
  { label: "Gaming", value: "Gaming" },
  { label: "Phone Refill", value: "Phone Refill" },
  { label: "International Top Up", value: "International Top Up" },
];

export const chipStyle = {
  height: 40,
  fontSize: "12px",
  borderRadius: "100px",
  display: "flex",
  alignItems: "center",
  padding: "0 12px",
  backgroundColor: "#002926",
  border: "1px solid #ddd",
  color: "#fff",
};

// Using your common style object
export const commonSelectStyle = {
  fontSize: "12px",
  height: 40,
  width: 150,
  py: 1,
  "& .MuiSelect-select": {
    paddingY: "10px", // Adjust this if needed
    display: "flex",
    alignItems: "center",
  },
};

export const CustomerStatusOption: any = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Banned", value: "ban" },
];
